import React, { useRef, useState, useEffect } from "react";
import { maybeDecryptResponse } from '../../utils/responseCrypto';

const MediaPlayer = ({ vidUrl, height, width, onEnded ,TrackLessonView=null,lastPosition=0}) => {
  const isDevMode = localStorage.getItem('development') || false;
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [mediaType, setMediaType] = useState("video"); // 'ppt' or 'video'
  const [pptUrl] = useState(
    "https://view.officeapps.live.com/op/embed.aspx?src=https://file-examples-com.github.io/uploads/2017/08/file_example_PPT_500kB.ppt"
  );
  const [videoUrl] = useState("");
  const [duration, setDuration] = useState(0);

  const videoRef = useRef(null);
  const progressIntervalRef = useRef(null);

  // Start sending progress updates every 5 seconds while playing
  const startProgressTracking = () => {
    if (progressIntervalRef.current) return; // already tracking

    progressIntervalRef.current = setInterval(() => {
      if (videoRef.current) {
        const time = videoRef.current.currentTime;
        TrackLessonView && TrackLessonView('video',"video_progress", { currentTime: time, duration });
      }
    }, 5000);
  };

  // Stop progress tracking interval
  const stopProgressTracking = () => {
    if (progressIntervalRef.current) {
      clearInterval(progressIntervalRef.current);
      progressIntervalRef.current = null;
    }
  };

  // Event handlers for video element
  const handlePlay = () => {
    const currentTime = videoRef.current.currentTime;
    TrackLessonView && TrackLessonView('video',"video_played", { currentTime , duration });
    startProgressTracking();
  };

  const handlePause = () => {
    const currentTime = videoRef.current.currentTime;
    TrackLessonView && TrackLessonView('video',"video_paused", { currentTime, duration });
    stopProgressTracking();
  };

  const handleEnded = () => {
    const currentTime = videoRef.current.currentTime;
    TrackLessonView && TrackLessonView('video',"video_ended", { currentTime, duration });
    stopProgressTracking();
    onEnded && onEnded(); // Call the onEnded prop if provided
  };


  // Cleanup on unmount
  useEffect(() => {
    return () => {
      stopProgressTracking();
    };
  }, []);
  const [videoSrc, setVideoSrc] = useState(null);
  useEffect(() => {
    let objectUrl;
        const fetchVideo = async () => {
      if (vidUrl && token) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/videos/get-cdn-video/${vidUrl}`, { headers: { Authorization: `Bearer ${token}`}}
          );

          if (!response.ok) {
            throw new Error("Failed to fetch video metadata");
          }
          const data = await response.json();   // ✅ parse JSON
          const videoData = await maybeDecryptResponse(data);          

          if (videoData.videoUrl) {
            setVideoSrc(videoData.videoUrl);         // ✅ use videoUrl from JSON
          } else {
            setVideoSrc(""); // fallback if not found
          }

        } catch (err) {
          console.error("Error fetching video:", err);
          setVideoSrc(""); // fallback
        }
      } else {
        setVideoSrc(""); // fallback if vidUrl/token missing
      }
    };

    fetchVideo();

    return () => {
      if (videoUrl) URL.revokeObjectURL(videoUrl);
    };
    // eslint-disable-next-line
  }, [vidUrl, token]);
  return (
    <div style={{ maxWidth: 800, margin: 'auto', inlineSize: '100%', blockSize: '100%' }}>

      {mediaType === "ppt" && (
        <iframe
          src={pptUrl}
          width={width}
          height={height}
          frameBorder="0"
          title="PowerPoint Presentation"
          allowFullScreen
          style={{ border: "1px solid #ccc" }}
          tabIndex="0"
          
        ></iframe>
      )}

      {mediaType === "video" && (
        <video
          ref={videoRef}
          width={width}
          height={height}
          controls
          src={videoSrc}
          onLoadedMetadata={() => {
            if (videoRef.current) {
              setDuration(videoRef.current.duration);
              videoRef.current.currentTime = lastPosition;
            }
          }
          }
          onPlay={handlePlay}
          onPause={handlePause}
          onEnded={handleEnded}
          autoPlay={true}
          preload="metadata"
          controlsList="nodownload" 
          playsInline
          className={!isDevMode ? "hide-seek-bar" : ""}
        >
          Sorry, your browser does not support the video tag.
        </video>
      )}
    </div>
  );
};

export default MediaPlayer;
